module.exports = __webpack_public_path__ + "media/1x1/qa-78909a6f.svg";